import dayjs from "dayjs";

import { getAllManagedUsersOfAdvisors } from "../../../../../../../utils/helper/specialized";
import { getSavedProposalsAll } from "../../../../super_admin/helper";

export const getAnalyticCalculation = ({
  managedUsers,
  managedUserManagers,
  productsList,
  searchQuarter,
  searchYear,
}) => {
  if (!managedUserManagers) return {};

  managedUsers =
    managedUsers ?? getAllManagedUsersOfAdvisors(managedUserManagers);

  const listProposals = getSavedProposalsAll({
    managedUsers,
    productsList,
  }).filter(it => {
    const proposalSavedYear = +dayjs(it.updatedAt).format("YYYY");
    const proposalSavedQuarter = dayjs(it.updatedAt).quarter();

    return (
      proposalSavedYear === searchYear && proposalSavedQuarter === searchQuarter
    );
  });

  const totalProposedAum = listProposals.reduce(
    (acc, it) => acc + it.investmentAmount,
    0
  );

  const addedCustomers = managedUsers.filter(it => {
    const creationYear = +dayjs(
      it.valueMap?.guideInitialData?.startDate
    ).format("YYYY");

    const creationQuarter = dayjs(
      it.valueMap?.guideInitialData?.startDate
    ).quarter();

    return creationYear === searchYear && creationQuarter === searchQuarter;
  });

  const advisorsWithLoginDate = managedUserManagers.filter(
    it => it.userManager?.lastLoginTime?.$date
  );

  const quantityActiveAdvisors1Day = advisorsWithLoginDate.filter(it =>
    dayjs(it.userManager.lastLoginTime.$date).isAfter(
      dayjs().subtract(1, "day")
    )
  ).length;

  const quantityActiveAdvisors1To2Days = advisorsWithLoginDate.filter(
    it =>
      dayjs(it.userManager.lastLoginTime.$date).isAfter(
        dayjs().subtract(2, "day")
      ) &&
      dayjs(it.userManager.lastLoginTime.$date).isBefore(
        dayjs().subtract(1, "day")
      )
  ).length;

  const quantityActiveAdvisors7Days = advisorsWithLoginDate.filter(it =>
    dayjs(it.userManager.lastLoginTime.$date).isAfter(
      dayjs().subtract(7, "day")
    )
  ).length;

  const quantityActiveAdvisors7To14Days = advisorsWithLoginDate.filter(
    it =>
      dayjs(it.userManager.lastLoginTime.$date).isAfter(
        dayjs().subtract(14, "day")
      ) &&
      dayjs(it.userManager.lastLoginTime.$date).isBefore(
        dayjs().subtract(7, "day")
      )
  ).length;

  const quantityActiveAdvisors30Days = advisorsWithLoginDate.filter(it =>
    dayjs(it.userManager.lastLoginTime.$date).isAfter(
      dayjs().subtract(30, "day")
    )
  ).length;

  const quantityActiveAdvisors31To60Days = advisorsWithLoginDate.filter(
    it =>
      dayjs(it.userManager.lastLoginTime.$date).isAfter(
        dayjs().subtract(60, "day")
      ) &&
      dayjs(it.userManager.lastLoginTime.$date).isBefore(
        dayjs().subtract(31, "day")
      )
  ).length;

  return {
    quantityActiveAdvisors1Day,
    quantityActiveAdvisors1To2Days,
    quantityActiveAdvisors7Days,
    quantityActiveAdvisors7To14Days,
    quantityActiveAdvisors30Days,
    quantityActiveAdvisors31To60Days,
    quantityAddedCustomers: addedCustomers.length,
    quantityProposals: listProposals.length,
    totalProposedAum,
  };
};
